import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { fetchPublicSettings } from '../../api/settings';

const SiteSettingsContext = createContext(null);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchPublicSettings()
      .then((data) => {
        if (!cancelled) setSettings(data.settings || {});
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setReady(true);
      });
    return () => { cancelled = true; };
  }, []);

  const refresh = () => {
    fetchPublicSettings()
      .then((data) => setSettings(data.settings || {}))
      .catch(() => {});
  };

  const value = useMemo(() => ({ settings, ready, refresh }), [settings, ready]);

  return (
    <SiteSettingsContext.Provider value={value}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  const ctx = useContext(SiteSettingsContext);
  if (!ctx) {
    return { settings: {}, ready: true, refresh: () => {} };
  }
  return ctx;
}
